import { render, staticRenderFns } from "./User.vue?vue&type=template&id=2fe86d6a&scoped=true"
var script = {}
import style0 from "./User.vue?vue&type=style&index=0&id=2fe86d6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe86d6a",
  null
  
)

export default component.exports